import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="py-24 md:py-40 px-6 bg-gradient-to-br from-coral via-[#FF5A36] to-[#E63946] relative overflow-hidden" data-id="element-126">
      {/* Decorative background blobs */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-127">
        <div className="absolute -top-40 -left-40 w-96 h-96 bg-yellow/30 rounded-full blur-3xl animate-blob" data-id="element-128"></div>
        <div className="absolute -bottom-40 -right-40 w-96 h-96 bg-white/20 rounded-full blur-3xl animate-blob" style={{
        animationDelay: '2s'
      }} data-id="element-129"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-131">
          <h2 className="text-4xl md:text-6xl font-extrabold text-white mb-6 tracking-tight leading-[1.1]" data-id="element-132">
            Tour Funtastic Kidz this week.
          </h2>
          <p className="text-xl md:text-2xl text-white/90 mb-12 max-w-2xl mx-auto font-medium" data-id="element-133">
            Three tour slots this week. 30 minutes each. No enrolment pressure.
            Bring your questions about CCS, fees, days, or your child's specific
            needs.
          </p>

          <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-4" data-id="element-134">
            <a href="#tours" className="bg-yellow text-navy px-8 py-5 rounded-btn font-extrabold text-lg hover:bg-white transition-colors shadow-lg hover:shadow-xl hover:-translate-y-1 transform duration-200" data-id="element-135">
              Book a tour Tuesday 10am
            </a>
            <a href="#tours" className="bg-teal text-white px-8 py-5 rounded-btn font-extrabold text-lg hover:bg-teal-light hover:text-teal transition-colors shadow-lg hover:shadow-xl hover:-translate-y-1 transform duration-200" data-id="element-136">
              Book a tour Wednesday 2pm
            </a>
            <a href="#tours" className="bg-white text-coral px-8 py-5 rounded-btn font-extrabold text-lg hover:bg-sand transition-colors shadow-lg hover:shadow-xl hover:-translate-y-1 transform duration-200" data-id="element-137">
              Book a tour Thursday 4:30pm
            </a>
          </div>

          <div className="mt-10" data-id="element-138">
            <a href="tel:0387143350" className="inline-flex items-center gap-2 text-white hover:text-yellow font-bold text-xl transition-colors border-b-2 border-transparent hover:border-yellow pb-1" data-id="element-139">
              Or call 03 8714 3350
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}